<script>
	export let label;
	export let index;
	export let states;
	export let products;
	export let edit = undefined;
	export let filter = undefined;
	import MultiSelect from '../components/MultiSelect.svelte';
</script>

<style>
	.grid {
		display: grid;
		grid-gap: 10px;
		grid-template-columns: repeat(auto-fit, 20em);
	}
	.grid > div {
		border: solid;
		position: relative;
	}
	.terpene {
		width: 50%;
	}
	.input > input {
		margin-left: .75em;
		width: 10em;
	}
	.input > input[type="number"] {
		width: 5em;
		margin-right: 5em;
		text-align: right;
	}
	.input {
		text-align: right;
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		display: none;
	}
	.grid button {
		width: 100%;
	}
	.kissass {
		position: absolute;
		left: 0;
		bottom: 0;
	}
	textarea {
		width: 97%;
		height: 120px;
	}
</style>

<label>{label}
	<MultiSelect
		bind:selected={states[index]}
		bind:list={products}
		display={item => item.brand + ' ' + item.clean_title + ' ' + item.type}
		{filter}
		family="{index}-products"
	/>
</label>
<div class="grid">
	{#each states[index] || [] as item}
		<div>
			<button on:click={() => edit = item}>choose and reorder pictures ({products[item].img.length} / {products[item].image_paths.length} selected)</button><br>
			<div class="input">
				<label>brand</label>
				<input bind:value={products[item].brand}>
			</div>
			<div class="input">
				<label>title</label>
				<input bind:value={products[item].clean_title}>
			</div>
			<div class="input">
				<label>type</label>
				<input bind:value={products[item].type}>
			</div>
			<div class="input">
				<label>strain</label>
				<input bind:value={products[item].strain}>
			</div>
			<div class="input">
				<label>unit of measurement</label>
				<input bind:value={products[item].UOM}>
			</div>
			<div class="input">
				<label>stock{typeof products[item].stock}</label>
				<input type="number" bind:value={products[item].stock}>
			</div>
			<div class="input">
				<label>portions</label>
				<input type="number" bind:value={products[item].portions}>
			</div>
			<div class="input">
				<label>quantity</label>
				<input type="number" bind:value={products[item].quantity}>
			</div>
			<div class="input">
				<label>price</label>
				<input type="number" bind:value={products[item].price}>
			</div>
			<div class="input">
				<label>minimum THC{typeof products[item].thc_min}</label>
				<input type="number" bind:value={products[item].thc_min}>
			</div>
			<div class="input">
				<label>maxmimum THC</label>
				<input type="number" bind:value={products[item].thc_max}>
			</div>
			<div class="input">
				<label>minimum CBD</label>
				<input type="number" bind:value={products[item].cbd_min}>
			</div>
			<div class="input">
				<label>maxmimum CBD</label>
				<input type="number" bind:value={products[item].cbd_max}>
			</div>
			<label>description<textarea bind:value={products[item].description}></textarea></label>
			<label>
				terpenes<br>
				{#each products[item].terpenes as terpene, j}
					<input class="terpene" type="search" on:search={() => {if(terpene.length === 0) {products[item].terpenes.splice(j, 1); products = products;}}} bind:value={products[item].terpenes[j]}>
				{/each}
				<div>&nbsp;</div>
				<button class="kissass" on:click={() => {products[item].terpenes.push(''); products = products;}}>add terpene</button>
			</label>
		</div>
	{/each}
</div>